// eslint-disable-next-line import/no-anonymous-default-export
export default {
  development: 'development',
  local: 'local',
  production: 'production',
  staging: 'staging',
};
